export function ReportSkeleton({ label = "Loading selected report…" }: { label?: string }) {
  return <div role="status" aria-busy="true" aria-label={label} className="space-y-3 py-3">
    <span className="sr-only">{label}</span>
    <div aria-hidden="true" className="motion-safe:animate-pulse space-y-3">
      <div className="h-6 w-1/3 rounded-lg bg-slate-200" />
      {[0, 1, 2, 3].map(row => <div key={row} className="grid grid-cols-3 gap-4"><div className="col-span-2 h-8 rounded-lg bg-slate-100" /><div className="h-8 rounded-lg bg-slate-100" /></div>)}
    </div>
  </div>;
}
